<div class="page-content page-fill">
  <div class="row flex-fill">
    <div class="col-4 flex-fill border-end">
      <div class="grid-fill">
        <dx-data-grid
          #peopleGrid
          [dataSource]="people"
          keyExpr="id"
          [wordWrapEnabled]="true"
          [showBorders]="true"
          [rowAlternationEnabled]="false"
          [focusedRowEnabled]="true"
          (onFocusedRowChanged)="focusedRowChanged()"
          >
          <dxi-column dataField="firstName" [sortIndex]="2" [sortOrder]="'asc'"></dxi-column>
          <dxi-column dataField="lastName" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>

          <dxo-filter-row [visible]="true"></dxo-filter-row>
          <!-- <dxo-filter-panel [visible]="true"></dxo-filter-panel> -->
          <!-- <dxo-header-filter [visible]="false"></dxo-header-filter> -->
          <!-- <dxo-remote-operations [sorting]="true" [paging]="true" [filtering]="true"></dxo-remote-operations> -->
          <dxo-selection mode="single"></dxo-selection>
          <!-- <dxo-scrolling mode="virtual" showScrollbar="always" [preloadEnabled]="true"></dxo-scrolling> -->
          <!-- <dxo-paging [pageSize]="50"></dxo-paging> -->
          <!-- <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 20, 50]" [showNavigationButtons]="true" [showInfo]="true"></dxo-pager> -->
          <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="interestPeopleGrid"></dxo-state-storing>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <!-- <dxo-grouping [contextMenuEnabled]="true"></dxo-grouping> -->
          <!-- <dxo-group-panel [visible]="true"></dxo-group-panel> -->
        </dx-data-grid>
      </div>
    </div>
    <div class="col-8 flex-fill">
      @if (selectedPerson) {
        <div class="mx-3">
          <div class="mb-4">
            <dx-button text="Edit Survey" type="default" (onClick)="edit()"></dx-button>
          </div>
          <h2>{{ selectedPerson.firstName }} {{ selectedPerson.lastName }}</h2>
          <div class="">
            <div [hidden]="!selectedPerson.email">{{ selectedPerson.email }}</div>
            <div [hidden]="!selectedPerson.cellPhone">cell: {{ selectedPerson.cellPhone }}</div>
            <div [hidden]="!selectedPerson.homePhone">home: {{ selectedPerson.homePhone }}</div>
            <div [hidden]="!selectedPerson.family?.homePhone">home: {{ selectedPerson.family?.homePhone }}</div>
          </div>
          <div class="mt-3">
            @if (selectedPerson.interestsLastUpdated) {
              <h3>Last Updated on {{ selectedPerson.interestsLastUpdated | date: 'M/d/yyyy' }}</h3>
            }
            @for (i of personInterests; track i) {
              <div>
                {{ (i.interest?.interestCategory ? i.interest.interestCategory.name + ' - ' : '') + i.interest.name }}
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
